import { Card } from 'flowbite-react';
import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router';

import { ApiError } from '../../../api/apiError';
import { useApi } from '../../../api/useApi.hook';
import { ErrorSwitch } from '../../../components/errorMessage/errorSwitch.component';
import { Loading } from '../../../components/loading/loading.component';
import { ProductLogo } from '../../components/productLogo/productLogo.component';
import { RouteIndex } from '../../routeIndex';

const AuthView = () => {
    const api = useApi();
    const [searchParams] = useSearchParams();

    const navigate = useNavigate();
    const [ isLoading, setIsLoading ] = useState(true);
    const [ error, setError ] = useState<Error|ApiError|string|null>(null);

    const token = searchParams.get('token');

    useEffect(() => {
        if (!token) {
            setIsLoading(false);
            setError('InvalidLink');
            return;
        };

        const establishSession = async () => {
            // Verify magic link and get new session
            const result = await api.v1.auth.provider.magicLink.verifyMagicLink(token);

            // Establish session - this handles revoking old session (if any)
            // Query invalidation is handled by main.view.tsx on sessionEstablished event
            await api.client.establishSession(result.tokens, {
                revokeOldSession: (sessionId) => api.v1.identities.revokeMySession(sessionId)
            });

            navigate('/');
        };

        establishSession().catch(err => {
            setError(err);
            setIsLoading(false);
        });
    }, [token]);

    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100 p-2">
            <Card className="p-4 w-full max-w-sm shadow-lg">
                <ProductLogo className='text-center' />

                <div className='w-full border-t border-t-gray-200' />

                <h4 className="text-xl font-semibold text-center">Přihlášení</h4>

                {isLoading && (
                    <div className='flex flex-row items-center justify-center'>
                        <Loading label='Probíhá ověřování odkazu...' />
                    </div>
                )}

                <ErrorSwitch
                    className='text-center'
                    error={error}
                    options={[
                        { returnCode: 'InvalidLink', message: 'Odkaz je neplatný nebo již vypršel. Přihlaste se prosím znovu.' },
                        { reasonCode: 'AccountDisabled', message: 'Váš účet byl deaktivován. Kontaktujte prosím podporu.' }
                    ]}
                    default={{ message: 'Nastala neočekávaná chyba. Zkus prosím obnovit stránku nebo znovu kliknout na odkaz v e-mailu.' }}
                />

                {!isLoading && (
                    <div className="flex flex-col justify-center items-center gap-4">
                        <Link to={RouteIndex.login} className='hyperlink text-sm'>Zpět na přihlášení</Link>
                    </div>
                )}
            </Card>
        </div>
    );
};

export default AuthView;
